import { ApiStatus, DropDownOptions } from '../../types';
import { LiabilitiesTemplate } from '../../utils/displayLiabilitiesFields';

export const otherLiabilitiesDefaultContent = {
    'heading': '{heading placeholder}',
    'description': '{description placeholder}',
    'addLiabilitiesButtonText': '{addLiabilitiesButtonText placeholder}',
    'cancelButtonText': '{cancelButtonText placeholder}',
    'confirmButtonText': '{confirmButtonText placeholder}',
    'notificationHeading': '{notificationHeading}',
    'notificationText': '{notificationText}',
    'editLiabilitiesButtonText': '{edit}',
    'deleteLiabilitiesButtonText': '{delete}',
    'accountInfo': '{accountInfo}',
    'balanceLabel': '{accountBalanceLabel}',
    'balanceMissingMessage': '{accountBalanceMissingMessage}',
    'creditLimitLabel': '{accountCreditLimitLabel}',
    'creditLimitMissingMessage': '{accountCreditLimitMissingMessage}',
    'repaymentLabel': '{accountRepaymentLabel}',
    'repaymentMissingMessage': '{accountRepaymentMissingMessage}',
    'shareRepaymentLabel': 'accountShareRepaymentLabel',
    'shareRepaymentMissingMessage': '{accountShareRepaymentMissingMessage}',
    'addLiabilities': {
        'heading': '{addLiabilitiesHeading placeholder}',
        'confirmButtonText': '{confirmButtonText placeholder}',
        'cancelButtonText': '{cancelButtonText placeholder}',
    },
    'editLiabilities': {
        'heading': '{editLiabilitiesHeading placeholder}',
        'confirmButtonText': '{confirmButtonText placeholder}',
        'cancelButtonText': '{cancelButtonText placeholder}',
    },
    'liabilityType': {
        'label': 'Liability type',
        'placeholder': 'Select',
    },
    'institution': {
        'label': 'Institution',
        'placeholder': 'Type or Search',
    },
    'creditLimit': {
        'label': 'Credit limit',
        'placeholder': '$',
    },
    'repayment': {
        'label': 'Repayments',
        'placeholder': '$',
    },
    'noOtherLiabilities': {
        'heading': '{noLiabilityHeading placeholder}',
        'description': '{noLiabilityHeading description}',
        'confirmButtonText': '{noLiabilityConfirmButtonText}',
        'cancelButtonText': '{noLiabilityCancelButtonText}',
    },
    'repaymentFrequency': {
        'label': 'How often',
        'placeholder': 'Select',
    },
    'currentBalance': {
        'label': 'Current Balance',
        'placeholder': '$',
    },
    'liabilityShareOption': {
        'label': 'This loan is',
        'placeholder': 'Select',
    },
    'repaymentShare': {
        'label': 'Repayment(Just your share)',
        'placeholder': '$',
    },
};

export const otherLiabilityTypesContent: DropDownOptions<string>[] =  [
    {
        'key': 'Other Liability',
        'value': '49',
    },
    {
        'key': 'Hire Purchase',
        'value': '46',
    },
    {
        'key': 'Personal Loan',
        'value': '45',
    },
    {
        'key': 'Business Loan',
        'value': '42',
    },
    {
        'key': 'Lease',
        'value': '37',
    },
    {
        'key': 'Margin Loan',
        'value': '35',
    },
    {
        'key': 'Investment Home Loan',
        'value': '34',
    },
    {
        'key': 'Home Loan',
        'value': '33',
    },
    {
        'key': 'Line of Credit',
        'value': '31',
    },
    {
        'key': 'Overdraft',
        'value': '30',
    },
    {
        'key': 'Credit Card',
        'value': '27',
    },
];

export const liabilitiesValidationsContent = {
    'hardValidations': {
        'liabilityType': {
            'defaultErrorMessage': 'Select liability type',
        },
        'currentBalance': {
            'defaultErrorMessage': 'Enter balance owing',
            'minValue': '0.01',
            'minValueMessage': 'Amount must be positive',
        },
        'liabilityShareOption': {
            'defaultErrorMessage': 'Select an option',
        },
        'repayment': {
            'defaultErrorMessage': 'Enter repayment amount',
            'minValue': '0.01',
            'minValueMessage': 'Amount must be positive',
        },
        'institution': {
            'defaultErrorMessage': 'Select an institution',
        },
        'creditLimit': {
            'defaultErrorMessage': 'Enter credit limit',
            'minValue': '0.01',
            'minValueMessage': 'The credit limit seems low. Check you`ve entered the correct amount.',
        },
        'repaymentShare': {
            'defaultErrorMessage': 'Enter share of repayment',
            'maxValueMessage': 'Enter a share less than the total repayment amount',
            'minValue': '0.01',
            'minValueMessage': 'The repayment share seems low. Check you`ve entered the correct amount.',
        },
        'repaymentFrequency': {
            'defaultErrorMessage': 'Select a repayment frequency',
        },
        'confirmButtonText': {
            'defaultErrorMessage': '{confirmButtonDefaultErrorMessage}',
        },
    },
};

export const deleteLiabilitiesContent = {
    'heading': '{deleteHeading}',
    'description': '{description placeholder}',
    'confirmButtonText': '{confirmButtonText placeholder}',
    'cancelButtonText': '{cancelButtonText placeholder}',
};

export interface OtherLiabilitiesResponse {
    otherLiabilities: Record<number, OtherLiabilityDetails>;
    content: string;
    referenceData: ReferenceData;
}

export interface OtherLiabilitiesItem {
    liabilityId?: string;
    accountNumber: string;
    liabilityTypeId: string;
    liabilityGroup?: LiabilitiesTemplate;
    financialInstitutionId: string;
    creditLimit: string;
    currentBalance: string;
    repaymentAmount: string;
    repaymentFrequencyId: string;
    liabilityShareOption: string;
    repaymentShare: string;
    isDeleted: boolean;
}

export interface OtherLiabilityDetails extends OtherLiabilitiesItem  {
    recordNumber?: number;
    liabilityTitle?: string;
    isEditMode?: boolean;
}

export interface OtherLiabilitiesBaseRef {
    id: string;
    description: string;
}

export interface OtherLiabilityShareOptions extends OtherLiabilitiesBaseRef {
    isShareLiability: boolean;
}

export interface OtherLiabilitiesLiabilityTypes extends OtherLiabilitiesBaseRef {
    liabilityGroup: LiabilitiesTemplate;
}

export interface ReferenceData {
    liabilityTypes: OtherLiabilitiesLiabilityTypes[];
    financialInstitutions: OtherLiabilitiesBaseRef[];
    repaymentFrequencies: OtherLiabilitiesBaseRef[];
    liabilityShareOptions: OtherLiabilityShareOptions[];
}

export const liabilitiesDefaultContent = {
    ...otherLiabilitiesDefaultContent,
    liabilityTypes: otherLiabilityTypesContent,
    validations: liabilitiesValidationsContent,
    deleteLiabilities: deleteLiabilitiesContent,
};

export type OtherLiabilitiesApiEndPoints = {
    getLiabilitiesUrl: string
    updateLiabilitiesUrl?: string
};

export type UpdateOtherLiabilitiesEndpoints = {
    getLiabilitiesUrl?: string,
    updateLiabilitiesUrl?: string
}

export type OtherLiabilitiesDefaultContent = typeof liabilitiesDefaultContent;

export type OtherLiabilitiesState = {
    content: OtherLiabilitiesDefaultContent
    otherLiabilities: Record<number, OtherLiabilityDetails>
    lastVisitedItem: {
        id: number | null
        mode: 'add' | 'edit' | null
        isSaved: boolean
    }
    referenceData: ReferenceData
    isAddMode: boolean
    apiEndPoints: OtherLiabilitiesApiEndPoints
    apiStatus: ApiStatus
}

export interface OtherLiabilitiesSubmitResponse {
    otherLiabilities: OtherLiabilitiesItem[];
}

